export default __webpack_public_path__ + "static/media/CheckCircle.8c110cf0.svg";